import { client, handleClientMethod } from "../client";
import type { QueryResult, QueryExecutionApiResponse } from "@onsemble/shared/types/internal";

export async function executeQuery(queryId: string): Promise<QueryResult> {
  const response = await handleClientMethod<QueryExecutionApiResponse>(
    client.POST("/api/internal/products/queries/{id}/execute", {
      params: {
        path: { id: queryId },
      },
    })
  );
  return response.data;
}
